/**
 * These assemblies are available for use in Components.
 * These components can only embed those available in the
 * RTE map.
 */
import { mapValues } from 'lodash';
import { SafeAssembly } from '../../error-boundaries';
import RTEAssembliesMap from './rte';

// keep this list in alphabetical order
import { AccordionsAssembly } from '../../accordion/accordions';
import { AdviceLinksAssembly } from '../../advice-links';
import { AlertCalloutAssembly } from '../../alert-callout';
import { BannerAssembly } from '../../banner';
import { BrandHeroAssembly } from '../../hero-brand';
import { BylineBannerAssembly } from '../../byline-banner';
import { CalloutBoxAssembly } from '../../callout-box';
import { CardsWithIconsAssembly } from '../../cards-with-icons';
import { ContentBlockAltAssembly } from '../../content-block-alt';
import { CardGridAssembly } from '../../card-grid-assembly';
import { ContentCardLinksAssembly } from '../../card-links-assembly';
import { ContentGridAssembly } from '../../content-grid';
import { CountdownTimerAssembly } from '../../countdown-timer';
import { CTABannerAssembly } from '../../cta-banner';
import { DatawrapperAssembly } from '../../datawrapper';
import { DonationBannerAssembly } from '../../donation-banner';
import { DownloadBannerAssembly } from '../../download-banner';
import { EventCardAssembly } from '../../event-card';
import { FormAssembly } from '../../form';
import { FullWidthImageAssembly } from '../../image/full-width-image';
import { GraphAssembly } from '../../graph';
import { IframeEmbedAssembly } from '../../iframe-embed';
import { InstagramFeedAssembly } from '../../instagram-feed';
import { LinkBoxAssembly } from '../../link-box';
import { PerksAssembly } from '../../perks';
import { PersonCollectionAssembly } from '../../person/collection';
import { ShareBlockAssembly } from '../../share-block';
import { ShopFinderAssembly, ServiceFinderAssembly } from '../../finder';
import { SimpleRichTextBlockAssembly } from '../../simple-rich-text-block';
import { SignupFormAssembly } from '../../signup-form';
import { StatsAssembly } from '../../stats';
import { StepperAssembly } from '../../stepper';
import { StickyBannerAssembly } from '../../sticky-banner';
import { TestimonialsAssembly } from '../../testimonials';
import { ThreeColumnRichTextAssembly } from '../../three-column-rich-text';
import { TileGridAssembly } from '../../tile-grid';
import { TimelineAssembly } from '../../timeline';
import { WebchatCtaAssembly } from '../../webchat-cta';

// keep this list in alphabetical order
const map = {
  ContentfulAssemblyAccordions: AccordionsAssembly,
  ContentfulAssemblyAdviceLinks: AdviceLinksAssembly,
  ContentfulComponentAlertCallout: AlertCalloutAssembly,
  ContentfulAssemblyContentBlockAlternating: ContentBlockAltAssembly,
  ContentfulAssemblyContentCardGrid: CardGridAssembly,
  ContentfulAssemblyCardLinks: ContentCardLinksAssembly,
  ContentfulAssemblyCardsWithIcon: CardsWithIconsAssembly,
  ContentfulAssemblyCta: CTABannerAssembly,
  ContentfulAssemblyDownloadBanner: DownloadBannerAssembly,
  ContentfulAssemblyForm: FormAssembly,
  ContentfulAssemblyPersonCollection: PersonCollectionAssembly,
  ContentfulAssemblyTestimonials: TestimonialsAssembly,
  ContentfulBlockDatawrapper: DatawrapperAssembly,
  ContentfulComponentBanner: BannerAssembly,
  ContentfulComponentBrandHero: BrandHeroAssembly,
  ContentfulComponentBylineBanner: BylineBannerAssembly,
  ContentfulComponentCalloutBox: CalloutBoxAssembly,
  ContentfulComponentChallengeEventPerksList: PerksAssembly,
  ContentfulComponentContentGrid4: ContentGridAssembly,
  ContentfulComponentCountdownTimer: CountdownTimerAssembly,
  ContentfulComponentDonationBanner: DonationBannerAssembly,
  ContentfulBlockCardEvent: EventCardAssembly,
  ContentfulComponentFullWidthImage: FullWidthImageAssembly,
  ContentfulComponentGraph: GraphAssembly,
  ContentfulComponentIframeEmbed: IframeEmbedAssembly,
  ContentfulComponentInstagramFeed: InstagramFeedAssembly,
  ContentfulComponentLinkBox: LinkBoxAssembly,
  ContentfulComponentServicesFinder: ServiceFinderAssembly,
  ContentfulComponentShareBlock: ShareBlockAssembly,
  ContentfulComponentShopFinder: ShopFinderAssembly,
  ContentfulComponentSimpleRichTextBlock: SimpleRichTextBlockAssembly,
  ContentfulComponentSignupForm: SignupFormAssembly,
  ContentfulComponentStats: StatsAssembly,
  ContentfulComponentStepper: StepperAssembly,
  ContentfulComponentStickyBanner: StickyBannerAssembly,
  ContentfulComponentThreeColumnRichText: ThreeColumnRichTextAssembly,
  ContentfulComponentTileGrid: TileGridAssembly,
  ContentfulComponentTimeline: TimelineAssembly,
  ContentfulComponentWebchatCta: WebchatCtaAssembly,
};

export default Object.assign(
  mapValues(map, (component) => SafeAssembly(component)),
  RTEAssembliesMap
);
